module.exports = __webpack_public_path__ + "static/media/karlsson-leather.64acbc6d.png";